import React from 'react'
import Modal from 'react-modal'
import { browserHistory } from 'react-router'

import NavLink from '../../Routes/NavLink'
import { modal } from '../../../core/utilities/modal';
import BankAccountSelect from '../../../helpers/BankAccounts/BankAccountSelect';
import { user } from '../../../core/controllers/user';
import { billing } from '../../../core/controllers/Billing';
import { modalStyles } from '../../../core/controllers/ModalStyles';
import { payable } from '../../../core/controllers/Payable';

import ActionCenterCard from '../../../helpers/Cards/ActionCenter';
import { ActionCenterEntry } from '../../../helpers/Cards/ActionCenter';

export default class BillActionCenter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasBank: false,
            showModal: false,
            bank: null
        }
    }

    componentDidMount() {
        var self = this;
        user.getUserDataWithCallback((response) => {
            if (response.data.user_data.billing_setup){
                billing.getProfile((response) => {
                    if(response.data.banks.length > 0) {
                        self.setState({
                            hasBank: true
                        });
                    }
                });
            }
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    payNow() {
        this.setState({
            showModal: true
        });
    }

    handleBankChange(e) {
        this.setState({
            bank: e.target.value
        });
    }

    handleCloseModal(didUpdate) {
        this.setState({
            showModal: false
        });
    }

    payBill() {
        if (this.state.bank == null) {
            modal.showInfo("Select a bank to make a payment.", "warning", "top", "center");
            return;
        }
        var self = this;
        modal.showDangerModalWithOK("Pay Bill Now?", "You will be charged <b>$" + this.props.amount + "</b>.", "Yes, Pay " + this.props.amount + "!");
		jQuery(".move-on").on('click',function() {
            payable.payBill(self.props.billId, self.state.bank, function(response) {
                modal.resetBackDrop();
                modal.showInfo("Bill successfully paid!", "success", "top", "center");
                browserHistory.goBack();
            });
        });
    }

    render(){
        const bank = this.state.bank;
        const amount = this.props.amount;
        const paymentStatus = this.props.paymentStatus;
        const userType = this.props.userType;
        var disabled = '';
        if (paymentStatus != 'NONE') {
            disabled = 'true';
        }

        var status = 'Not Paid';
        if (paymentStatus == 'IN_PROCESS') {
            status = 'In Pogress';
        } else if (paymentStatus == 'PAID') {
            status = 'Bill Paid';
        } else if (paymentStatus == 'FAILED') {
            status = 'Payment Failed';
        } else if (paymentStatus == 'VOID') {
            status = 'Payment Cancelled';
        }
        return (
            <ActionCenterCard>
                <ActionCenterEntry
                    title="Payment Status"
                    description={status}
                    buttonText={"Pay Now"}
                    buttonCallback={this.payNow.bind(this)}
                    disabled={disabled}
                    modal={
                        <Modal
                            isOpen={this.state.showModal}
                            onRequestClose={this.handleCloseModal.bind(this, false)}
                            style={modalStyles.getModalStyles()}
                            ariaHideApp={false}
                        >
                            <div class="row">
                                <div class="modal-exit-icon pull-right" onClick={this.handleCloseModal.bind(this, false)}></div>
                            </div>
                            <div class="row">
                                <div class="modal-header">Pay Bill</div>
                            </div>
                            <form>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label for="assignee">Which bank account do you want to pay from?</label>
                                                    <div class="clearfix"></div>
                                                    <BankAccountSelect sortID={bank} columnSize={0} title="Select bank for payment" onChange={this.handleBankChange.bind(this)} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-8 col-md-offset-4 col-sm-8 col-sm-offset-4 col-xs-8 col-xs-offset-3">
                                        <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.payBill.bind(this)}>
                                            Pay ${amount} Bill
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </Modal>
                    }
                />
            </ActionCenterCard>                
        )
    }
};



// WEBPACK FOOTER //
// app/components/Payables/Bill/BillActionCenter.jsx